// extracted by mini-css-extract-plugin
var _1 = "OverviewCommunicationSubtitle-moduleOverviewCommunicationSubtitle__NxDuY";
var _2 = "OverviewCommunicationSubtitle-moduledot__jMGtd";
var _3 = "OverviewCommunicationSubtitle-modulesubject__Pcqgw";
var _4 = "OverviewCommunicationSubtitle-moduleunit__C9Mhc OverviewCommunicationSubtitle-modulesubject__Pcqgw";
export { _1 as "OverviewCommunicationSubtitle", _2 as "dot", _3 as "subject", _4 as "unit" }
